import React, { useEffect } from "react";
import MapEditor from '../components/Map/MapEditor';
import Editors from "../components/Map/Editors";
import MapBuilder from '../components/Map/MapBuilder';
import { useDispatch } from "react-redux";
import { resetMap } from "../reducers/map/mapReducerActions";

const CreateMap = () =>  {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(resetMap());
    }, []);
    return (
        <MapEditor canEdit={true} editors={[<Editors key="editors" />]}>
            <MapBuilder />
        </MapEditor>
    );
};

export default CreateMap;
